import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },

  stats: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '120px 80px',
    gap: theme.spacing(6),

    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(0),
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'repeat(auto-fill, 100px)',
    },
  },

  stat: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '&:not(:last-of-type)': {
      borderRight: `1px solid ${alpha(theme.palette.common.white, 0.05)}`,
    },

    [theme.breakpoints.down('md')]: {
      height: 100,

      '&:not(:last-of-type)': {
        borderRight: 'none',
        borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.05)}`,
      },
    },
  },

  filledStat: {
    gridColumn: '1 / span 3',
    borderRadius: theme.spacing(4),
    background: alpha(theme.palette.common.white, 0.05),

    [theme.breakpoints.down('md')]: {
      gridColumn: '1',

      '&&': {
        borderBottom: 'none',
      },
    },
  },
}));
